import * as types from '@/constants/mutationTypes'

const state = {
  activeUser: {
    company: '5d9d7da7c275ed4401de9985',
    deleteStatus: 1,
    disciplinaryAction: null,
    email: 'k.syndikat@gmail.com',
    firstName: 'founder',
    id: '5e09ca1d0e8c600011e57b71',
    isHrIncluded: false,
    isNotAssigned: false,
    lastName: 'founder',
    login: 'admin1',
    massMailingCheck: false,
    nextAssessment: null,
    role: 'founder',
    // eslint-disable-next-line max-len
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlMDljYTFkMGU4YzYwMDAxMWU1N2I3MSIsInVzZXJuYW1lIjoiZm91bmRlciIsInJvbGUiOiJmb3VuZGVyIiwiY29tcGFueSI6IjVkOWQ3ZGE3YzI3NWVkNDQwMWRlOTk4NSIsImV4cCI6MTY2NzgzMzY3NSwiaWF0IjoxNjYyNjQ5Njc1fQ.U3yj2r0DPy8OFoMtJMnV2d5eywjzOdUddXZJ92Ih3yk',
    username: 'founder founder',
    _id: '5e09ca1d0e8c600011e57b71'
  },
  contactsListMail: [],
  userListMail: []
}
const getters = {
  activeUser: state => state.activeUser,
  contactsListMail: state => state.contactsListMail,
  userListMail: state => state.userListMail
}
const actions = {
  setActiveUser ({commit}, data) {
    commit(types.SET_ACTIVE_USER, {data})
  },
  setContactListMail ({commit}, data) {
    commit(types.SET_CONTACT_LIST_MAIL, {data})
  },
  setUserListMail ({commit}, data) {
    commit(types.SET_USER_LIST_MAIL, {data})
  }
}
const mutations = {
  [types.SET_ACTIVE_USER] (state, {data}) {
    state.activeUser = data
  },
  [types.SET_CONTACT_LIST_MAIL] (state, {data}) {
    state.contactsListMail = data
  },
  [types.SET_USER_LIST_MAIL] (state, {data}) {
    state.userListMail = data
  }}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/User/modules/store.js